<template>
  <div class="content-area">
    <hero-bar>
      Servis Talebi Oluştur
      <b-button
        slot="right"
        icon-left="content-save-off"
        type="is-warning"
        class="mr-3"
        tag="router-link"
        :to="{ name: 'service_records.index' }"
      >
        {{ $t('cancel') }}
      </b-button>
      <b-button
        slot="right"
        icon-left="content-save"
        type="is-link"
        :class="{ 'is-loading': isLoading }"
        @click="submit"
      >
        {{ $t('save') }}
      </b-button>
    </hero-bar>

    <form ref="form" @submit.prevent="submit">
      <section class="section is-main-section">
        <card-component title="Servis Talebi Bilgileri" icon="code-greater-than-or-equal">
          <tiles>
            <div class="columns is-centered is-fullwidth">
              <div class="">
                <b-field class="has-text-centered" label="Talep Tarihi" />
                <b-datetimepicker
                  v-model="form.service_date"
                  :min-datetime="minDateTime"
                  :timepicker="{ incrementMinutes: 5 }"
                  :datepicker="{
                    monthNames: $t('dateTimePicker.monthNames'),
                    dayNames: $t('dateTimePicker.dayNames'),
                    firstDayOfWeek: 1
                  }"
                  inline
                  size="is-medium"
                />
              </div>
            </div>
            <div class="is-fullwidth">
              <h5 class="is-size-6 has-text-weight-bold mb-3">Talep Bilgileri</h5>
              <b-field>
                <b-select
                  v-model="form.request_unit"
                  placeholder="* Talep Eden Birim Seçiniz *"
                  validation-message="Lütfen talep eden birim seçiniz."
                  required
                  expanded
                >
                  <option
                    v-for="(requestUnit, index) in requestUnits"
                    :key="index"
                    :value="requestUnit.id"
                  >
                    {{ requestUnit.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field>
                <b-input
                  v-model="form.demandant_name"
                  type="text"
                  placeholder="Talep Eden Ad & Soyad"
                  name="demandant_name"
                />
              </b-field>
              <b-field>
                <b-input
                  v-model="form.demandant_phone"
                  v-cleave="masks.phone"
                  type="tel"
                  placeholder="Talep Eden Telefon"
                  name="demandant_phone"
                />
              </b-field>

              <b-field>
                <b-autocomplete
                  field="plate"
                  :data="cars"
                  placeholder="* Araç Plakasını Yazınız *"
                  :loading="isCarFetching"
                  @typing="getAsyncCarData"
                  @select="selectCar"
                >
                  <template slot-scope="props">
                    <span>
                      {{ props.option.plate }}
                      <span class="emptyText">({{ props.option.brand }} - {{ props.option.model }})</span>
                    </span>
                  </template>
                </b-autocomplete>
              </b-field>
            </div>
            
            <div class="is-fullwidth">
              <h5 class="is-size-6 has-text-weight-bold mb-3">Talep Türü</h5>
              <b-field>
                <b-select
                  v-model="form.service_type"
                  placeholder="* Talep Türü Seçiniz *"
                  validation-message="Lütfen talep türü seçiniz."
                  required
                  expanded
                >
                  <option
                    v-for="(serviceType, index) in serviceTypes"
                    :key="index"
                    :value="serviceType.id"
                  >
                    {{ serviceType.name }}
                  </option>
                </b-select>
              </b-field>
              <h5 class="is-size-6 has-text-weight-bold mb-3">{{ $t('aciklama') }}</h5>
              <b-field>
                <b-input
                  v-model="form.description"
                  maxlength="200"
                  rows="5"
                  type="textarea"
                  :placeholder="$t('aciklama')"
                />
              </b-field>
            </div>
          </tiles>
        </card-component>
      </section>
    </form>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import Cleave from 'cleave.js'
import 'cleave.js/dist/addons/cleave-phone.tr'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    CardComponent: () => import('@/components/CardComponent'),
    HeroBar: () => import('@/components/HeroBar'),
    Tiles: () => import('@/components/Tiles'),
  },
  title: ({ $i18n }) => $i18n.t('createServiceRecord'),
  directives: {
    cleave: {
      inserted: (el, binding) => {
        const input = el.querySelector('input')
        input.cleave = new Cleave(input, binding.value || {})
      },
      update: (el) => {
        const input = el.querySelector('input')
        const event = new Event('input', { bubbles: true });
        setTimeout(() => {
          input.value = input.cleave.properties.result
          input.dispatchEvent(event)
        }, 100);
      },
      unbind (el) {
        const input = el.querySelector('input')
        input.cleave.destroy()
      }
    }
  },
  data () {
    return {
      isLoading: false,
      formValid: false,
      isCarFetching: false,
      cars: [],
      form: {
        demandant_name: '',
        demandant_phone: '',
        description: '',
        service_date: null,
        car_id: null,
        duty_type: null,
        request_unit: null,
      },
      specification: {
        serviceTypes: [],
        requestUnits: [],
      },
      masks: {
        phone: {
          phone: true,
          phoneRegionCode: 'TR',
          delimiter: ' '
        }
      }
    }
  },
  computed: {
    ...mapState([
      'user',
    ]),
    ...mapGetters([
      'getSpecifications',
    ]),
    serviceTypes () {
      return this.getSpecifications(5)
    },
    requestUnits () {
      return this.getSpecifications(2)
    },
    minDateTime () {
      const minute = moment().format('m') % 5
      return moment().subtract(minute, 'minutes').add(15, 'minutes').toDate()
    }
  },
  beforeDestroy () {
    this.$store.commit('setAsideActiveMenuKey', '')
  },
  created () {
    this.$store.commit('setAsideActiveMenuKey', 'service_records.index')

    this.form.demandant_name = this.user.attributes.name
    this.form.demandant_phone = this.user.attributes.phone
  },
  mounted () {
    this.$store.dispatch('getSpecifications')

    this.form.service_date = this.minDateTime
  },
  methods: {
    getAsyncCarData: debounce(function (name) {
      this.cars = []

      if (!name.length) {
        return
      }

      this.isCarFetching = true
      
      this.$http.get('list-cars', {
        params: {
          transfer_id: 0, // no time to write dedicated endpoint (temporary workaround)
          estimated_time: 0, // no time to write dedicated endpoint (temporary workaround)
          q: name,
        }
      }).then(({ data }) => {
        this.cars = data
      }).catch(() => {
        this.cars = []
      }).finally(() => {
        this.isCarFetching = false
      })
    }, 500),
    selectCar (option) {
      if (option) {
        this.form.car_id = option.id
        this.cars = []
      }
    },
    submit () {
      let isValid = this.validateFormData(this.form)

      if (!isValid) {
        this.$buefy.toast.open({
          message: this.$t('checkFormValidation'),
          type: 'is-warning',
          duration: 5000
        })

        return false
      }

      this.isLoading = true

      const service_date = moment(this.form.service_date).format('YYYY-MM-DD HH:mm').toString()

      const params = {...this.form, ...{ service_date }}

      this.$http
        .post('service-records', params)
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            this.$buefy.toast.open({
              message: this.$t('transferCreated'),
              type: 'is-success',
              duration: 5000,
            })

            this.$router.push('/service-records')
          }
        })
        .catch(e => {
          const errors = this.$_.flattenDeep(this.$_.values(e.response.data.error.errors)).join('<br>');
            this.$buefy.toast.open({
              message: this.$t('error') + ': <br>' + errors,
              type: 'is-warning',
              duration: 5000
            });
            this.isLoading = false;
        });
    },
    validateFormData (data) {
      if (data.service_date === null) {
        return false
      }

      if (data.service_type === null || data.request_unit === null) {
        return false
      }

      if (data.car_id === null) {
        return false
      }

      return true
    },
    focusInput (e) {
      this.$nextTick()
        .then(() => {
          const vals = e.target.value;
          e.target.value = '';
          e.target.value = vals;
      })
    }
  }
}
</script>